import(/* webpackMode: "eager" */ "D:\\WORK\\ahli SEO\\Code\\ahliseo-frontend\\node_modules\\next\\dist\\client\\image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\WORK\\ahli SEO\\Code\\ahliseo-frontend\\src\\components\\common\\Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\WORK\\ahli SEO\\Code\\ahliseo-frontend\\src\\components\\common\\Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\WORK\\ahli SEO\\Code\\ahliseo-frontend\\src\\components\\common\\PostCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\WORK\\ahli SEO\\Code\\ahliseo-frontend\\src\\components\\ui\\FontAwesomeIcon.jsx");
